<template>
	<div class="ReSharePercent">
		<div >
		<!-- <div v-for="(obj, obj_index) in value" :key="obj_index"> -->
			<!-- <label class="mt-3 "><span>Стоимость за площадь части</span></label> -->

			<div class="d-flex " >
				<div class="fieldset " >
					<base-input
						type="number"
						placeholder="часть"
						v-model="value.sharePart"
						@blur="handlerBlur(value)"
					>
					</base-input>
					<base-input	
						type="number"
						placeholder="из"
						v-model="value.shareAll"
						@blur="handlerBlur(value)"
					>
					</base-input>
					<div class="btnGroup ">
						<button class="btn btn-icon btn-simple btn-danger no-border my-0" @click="clearValue()">
							<i class="d-inline-block tim-icons icon-simple-remove"></i>
						</button>
					</div>
					
				</div>
				
			</div>
			
		</div>
		<!-- <button class="btn btn-simple btn-primary" @click="addEmptyobjCost()">
			Дублировать стоимость
		</button> -->
	</div>
</template>

<script>
/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
	export default {
		name: 'ReSharePercent',
		components: {

		},
		props: {
			// counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			// value: [String,Array],
			value: {
				type: Object,
				default(){return {
					sharePart: '',
					shareAll: '',
					
				};}
			},
			label: String,
			// bShowView:{
			// 	type: Boolean,
			// 	default: true
			// },
		},
		data () {
			return {
				ver: 1,
				bufferValue: '',
			}
		},
		watch:{
			// value(val){
			// 	this.bufferValue = this.$GVO.unlinkObject(val);
			// },
			// bufferValue(val){
			// 	this.bufferValue = val;
			// 	this.$emit("input", this.bufferValue);
			// },
			
		},
		computed: {

		},
		methods: {
			clearValue(){
				this.value.sharePart = '';
				this.value.shareAll = '';
			},
			handlerBlur(element){
				// меняем в числах запятую на точку.
				// element.element_model = String(element.element_model).replace(',','.');
					if(element.sharePart && element.sharePart !=undefined){
						if(element.sharePart < 0 ){ 
							element.sharePart = element.sharePart * -1; //дедлаем значение положительным
						}
						element.sharePart = Math.floor(element.sharePart)
					}
					if(element.shareAll && element.shareAll !=undefined){
						if(element.shareAll < 0 ){ 
							element.shareAll = element.shareAll * -1; //дедлаем значение положительным
						}
						element.shareAll = Math.floor(element.shareAll);
					}
				// console.log('val', element);
			},
			// addEmptyobjCost(){
			// 	this.value.push({
			// 		square: '',
			// 		price: '',
			// 	});
				
			// },
			// delObjCost(ind){
				
			// 	this.value.splice(ind,1);
			// },

		},
	}
</script>
<style scoped>
	.ReSharePercent .fieldset{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
	}
	.ReSharePercent .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
	}
	/* .ReSquareCost .fieldset:not(.no-select) > div:nth-child(1){width: 250px;} */
	.ReSharePercent .btnGroup{
		display: flex;
		align-items: center;
	}
	.cc-item{
		margin-bottom: 15px;
	}
	.ReSharePercent >>> .el-input__inner {font-size: 0.75rem;}
	.ReSharePercent >>> .fieldset > div:nth-child(2) .form-control {height: 38px;}
	.ReSharePercent >>> .fieldset > div:nth-child(1) input {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.ReSharePercent >>> .fieldset > div:nth-child(2) input {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

</style>
